/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

function route (path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta,
    component: (resovle) => import(
      `@/views/${view}.vue`
    ).then(resovle)
  }
}

function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
  }
  return ''
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name, path.meta)).concat([
    { path: '*', redirect: '/login' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

export default router

router.beforeEach((to, from, next) => {
  var AdminCookies = getCookie('Token')
  if (to.meta.lms) {
    next()
  } else if (to.meta.requiresAuth) {
    if (AdminCookies.length > 1) {
      let AdminInfo = getCookie('Info')
      let obj = JSON.parse(AdminInfo)
      if (to.meta.isSuperAdmin) {
        if (obj.role_sequence === 0) {
          next()
        } else {
          next('/dashboard')
        }
      } else if (to.meta.isAdmin) {
        if (obj.role_sequence <= 1) {
          next()
        } else {
          next('/dashboard')
        }
      }
      next()
    } else {
      next('/login')
    }
  } else if (!to.meta.requiresAuth) {
    if (AdminCookies.length > 1) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    next()
  }
})
